import { userService, AuthError, NetworkError } from '../services/userService';
import { tokenService } from '../services/tokenService';
import router from '../router';

const state = {
  isAuthing: false,
  accessToken: tokenService.getToken(),
  authenticationErrorCode: 0,
  authenticationError: '',
  refreshTokenPromise: null,
};

const getters = {
  loggedIn: (state) => {
    return state.accessToken ? true : false;
  },

  authenticationErrorCode: (state) => {
    return state.authenticationErrorCode;
  },

  authenticationError: (state) => {
    return state.authenticationError;
  },

  isAuthing: (state) => {
    return state.isAuthing;
  },
};
const mutations = {
  loginRequest(state) {
    state.isAuthing = true;
    state.authenticationError = '';
    state.authenticationErrorCode = 0;
  },

  loginSuccess(state, accessToken) {
    state.accessToken = accessToken;
    state.isAuthing = false;
  },

  loginError(state, { errorCode, errorMessage }) {
    state.isAuthing = false;
    state.authenticationErrorCode = errorCode;
    state.authenticationError = errorMessage;
  },

  logoutSuccess(state) {
    state.accessToken = '';
  },
  refreshTokenPromise(state, promise) {
    state.refreshTokenPromise = promise;
  },
};

const actions = {
  async login({ commit }, { userCred }) {
    commit('loginRequest');
    try {
      const { accessToken, user } = await userService.login(userCred);
      commit('loginSuccess', accessToken);
      commit('user/setUser', user, { root: true });
      // ADD USER TO USERSTORE AND CHECK PREMISSIONS
      const isSuper = user.isEditor || user.isSupervisor;
      // Redirect the user to the page he first tried to visit or to the home view
      const redirect = router.history.current.query.redirect;
      router.push(
        redirect || (isSuper ? '/dashboard/employee' : '/attend_scan'),
      );

      return true;
    } catch (e) {
      if (e instanceof AuthError || e instanceof NetworkError) {
        commit('loginError', {
          errorCode: e.errorCode,
          errorMessage: e.message,
        });
      }
      // else if (e instanceof NetworkError) {
      //     commit('loginError', { errorCode: e.errorCode, errorMessage: e.message })
      // }
      return false;
    }
  },

  logout({ commit }) {
    userService.logout();
    commit('logoutSuccess');
    commit('user/setUser', null, { root: true });
    router.push('/');
  },
  refreshToken({ commit, state }) {
    // If this is the first time the refreshToken has been called, make a request
    // otherwise return the same promise to the caller
    if (!state.refreshTokenPromise) {
      const p = userService.getNewToken();
      commit('refreshTokenPromise', p);

      // Wait for the UserService.refreshToken() to resolve. On success set the token and clear promise
      // Clear the promise on error as well.
      p.then(
        (response) => {
          commit('refreshTokenPromise', null);
          commit('loginSuccess', response);
        },
        (error) => {
          commit('refreshTokenPromise', null);
        },
      );
    }

    return state.refreshTokenPromise;
  },
};

export const auth = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
